// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 729 ? "4d022aba" : chunkId) + "." + {"313":"e70858fe5a897b2d","425":"ee4d8dc70a2be390","436":"e0d328844150b081","525":"4aabd86afbbbd91b","729":"5bf90dddbf4ac190","752":"32e5fb6c789fac05","954":"0d7ec814ab32fad8","961":"7c302e444df31794","974":"215eaca349bf2692"}[chunkId] + ".js";
};